const getMatchedIndices = (text, searchTerm) => {
  if (!searchTerm) {
    return [];
  }
  const lowerText = text.toLowerCase();
  const lowerSearchTerm = searchTerm.toLowerCase();

  let textIndex = 0;
  let searchIndex = 0;
  const matchedIndices = [];

  while (textIndex < lowerText.length && searchIndex < lowerSearchTerm.length) {
    if (lowerText[textIndex] === lowerSearchTerm[searchIndex]) {
      matchedIndices.push(textIndex);
      searchIndex++;
    }
    textIndex++;
  }

  if (searchIndex !== lowerSearchTerm.length) {
      return []; // Not a full match
  }

  return matchedIndices;
};

export const getHighlightedText = (text, highlight) => {
    if (!highlight) {
        return <span>{text}</span>;
    }
    const matchedIndices = getMatchedIndices(text, highlight);
    if (matchedIndices.length === 0) {
        return <span>{text}</span>;
    }

    const parts = [];
    let lastIndex = 0;

    matchedIndices.forEach(matchIndex => {
        if (lastIndex < matchIndex) {
            parts.push(<span key={lastIndex}>{text.substring(lastIndex, matchIndex)}</span>);
        }
        parts.push(<strong key={matchIndex} style={{ color: '#000000', fontSize: '1.1em' }}>{text[matchIndex]}</strong>);
        lastIndex = matchIndex + 1;
    });

    if (lastIndex < text.length) {
        parts.push(<span key={lastIndex}>{text.substring(lastIndex)}</span>);
    }

    return <span>{parts}</span>;
}
